import axios from 'axios';

export const uploadToS3 = ({ uploadUrl, file, options }) => axios.put(uploadUrl, file, options);

export default {};
